<template>
    <div class="literature-page">
        <div class="df both-side">
            <a-space>

                <a-select v-model:value="requestPayload.catalog" :options="allCatalogOptions" @change="getData"
                    placeholder="目录" style="width: 160px;" allowClear></a-select>
                <a-select v-model:value="requestPayload.product" :options="allProductOptions"
                    @change="handleSelectProduct" placeholder="产品" style="width: 160px;" allowClear></a-select>
                <a-select v-model:value="requestPayload.model" :options="optionsByProduct" @change="getData"
                    placeholder="型号" style="width: 160px;" allowClear></a-select>

            </a-space>

            <a-space>
                <a-button size="small" type="primary" @click="handleUpdateLiterature('insert', null)">新增产品资料</a-button>

                <a-button size="small" type="default"
                    @click="handleUpdateLiterature('aboutInfo', null)">新增相关信息</a-button>



                <a-tooltip>
                    <template #title>同步浏览量</template>
                    <SyncOutlined spin @click="handleSyncPV" />
                </a-tooltip>
            </a-space>


        </div>

        <div class="space">
            <a-table :data-source="table.data" bordered :pagination="false"
                :scroll="{ x: 'calc( 100vw - 300px )', y: 'calc( 100vh - 280px )' }" :columns="columns" rowKey="id">
                <template #action="{ record }">
                    <!-- <a-space>
                        <a-button @click="handleUpdateLiterature('update', record)" type="primary"
                            size="small">修改</a-button>

                        <a-button @click="handleDeleteLiterature(record)" type="dange" size="small">删除</a-button>
                    </a-space> -->

                    <a-dropdown>
                        <template #overlay>
                            <a-menu @click="handleMenuClick($event, record)">
                                <a-menu-item key="update">修改</a-menu-item>
                                <a-menu-item key="delete">删除</a-menu-item>
                                <a-menu-item key="copy">复制链接</a-menu-item>
                            </a-menu>
                        </template>
                        <a-button size="small" type="primary">
                            操作
                            <DownOutlined />
                        </a-button>
                    </a-dropdown>

                </template>

                <template #content="{ record }">
                    <a-button @click="previewRecord(record)" size="small">预览</a-button>
                </template>

                <template #picture="{ record }">

                    <a-image-preview-group>
                        <template v-for="(url) in record.imgList" :key="url">
                            <a-image :width="50" :src="url" />
                        </template>

                    </a-image-preview-group>
                </template>

                <template #video="{ record }">
                    <video :src="url" v-for="(url) in record.videoList" :key="index" width="100px" height="100px"
                        controls></video>
                </template>

                <template #isDeactivate="{ record }">
                    <!-- <a-tag :color="record.isDeactivate ? '#f50' : '#87d068'">{{ record.isDeactivate ? '是' : '否'
                        }}</a-tag> -->
                    <a-switch checked-children="是" un-checked-children="否" v-model:checked="record.isDeactivate"
                        @click="handleUpdateDeativeate($event, record)" />
                </template>
            </a-table>
        </div>

        <literature-form ref="literatureFormRef" @handleUpdateTable="getData"></literature-form>

        <perview-modal ref="reviewModalRef"></perview-modal>
    </div>

</template>

<script>
import { defineComponent, reactive, ref, watch, computed } from "vue";
import { Toast, debounce } from "@/utils";
import { useTable } from "@/views/notice/serve/table";
import options from '@/components/cascader/option.js';
import { catalogOptions, allCatalogOptions, aboutProductOptions, getCopyLink } from './data';
import { getProductInfoList, deleteProductInfo, deleteProductInfoAnnex, saveProductInfo, syncProductInfoPV } from "@/request/view/productPublicityDept.js";
import { DownOutlined, SyncOutlined } from '@ant-design/icons-vue';
import literatureForm from '@/views/brand/Literature/form.vue';
import perviewModal from '@/views/brand/Literature/perview.vue';

export default defineComponent({
    components: {
        literatureForm,
        perviewModal,
        DownOutlined,
        SyncOutlined,
    },
    setup(props, context) {

        const literatureFormRef = ref();

        const reviewModalRef = ref();

        const allProductOptions = [
            ...aboutProductOptions,
            ...options.machineOptions,
        ];

        const {
            requestConfig,
            table,
            requestPayload,
            initPayload,
            getListData,
            searchData,
            deleteRecords,
            hanldeUpdatePageNum,
        } = useTable();

        requestConfig.pull_fn = getProductInfoList;
        requestConfig.delete_fn = deleteProductInfo;

        initPayload({
            catalog: null,
            model: null,
            product: null
        });

        const optionsByProduct = computed(() => {
            if (!requestPayload.product) return [];

            const filterList = options.machineOptions.filter((f) => f.value === requestPayload.product);

            if (filterList.length > 0) return filterList[0].children;

            return [];
        });

        const filterImgList = (str) => str.split('"').filter((f) => f.indexOf('http') !== -1 && (f.indexOf('png') !== -1 || f.indexOf('jpg') !== -1));

        const filterVideoList = (str) => str.split('"').filter((f) => f.indexOf('http') !== -1 && (f.indexOf('mp4') !== -1));

        const filterAnnpex = (str) => str.split('"').filter((f) => f.indexOf('http') !== -1);

        const getData = () => {
            getListData({ unPagingRequest: true }).then((res) => {
                table.data.forEach(item => {
                    item.content = item.content.replace(/192.168.72.1/g, '192.168.10.194:9008');

                    item.imgList = filterImgList(item.content);
                    item.videoList = filterVideoList(item.content);
                });
            });
        };

        const columns = [
            { title: "目录", dataIndex: "catalog", align: "center", width: "100px" },
            // { title: "文本框", dataIndex: "content", align: "center", width: "75px" },
            { title: "产品", dataIndex: "product", align: "center", width: "120px" },
            { title: "型号", dataIndex: "model", align: "center", width: "120px" },
            { title: "内容", dataIndex: "content", align: "center", width: "100px", slots: { customRender: "content" } },
            // { title: "图片", dataIndex: "picture", align: "center", width: "100px", slots: { customRender: "picture" } },
            // { title: "视频", dataIndex: "video", align: "center", width: "120px", slots: { customRender: "video" } },
            { title: "停用", dataIndex: "isDeactivate", align: "center", width: "100px", slots: { customRender: "isDeactivate" } },
            { title: "浏览量", dataIndex: "pv", align: "center", width: '120px' },
            { title: "分享次数", dataIndex: "sharingFrequency", align: "center", width: "100px" },
            { title: "更新时间", dataIndex: "updateTime", align: "center", width: "160px" },
            { title: "操作", dataIndex: "action", align: "center", width: "100px", slots: { customRender: "action" } }
        ];

        const handleUpdateLiterature = (type, data) => {
            const title = type === 'insert' ? '新增产品资料' : '更新产品资料';

            literatureFormRef.value.showModal(
                type, {
                title,
                data,
            });
        };

        const handleSelectProduct = () => {
            requestPayload.model = null;
            getData();
        };

        const deleteAnnex = (urlList) => {
            deleteProductInfoAnnex(urlList)
        };

        const handleDeleteLiterature = (record) => {
            deleteRecords([record.id], { title: "确认删除？" }).then(() => {
                const deleteList = filterAnnpex(record.content);
                deleteAnnex(deleteList);
                getData();
            });
        };

        const copyText = async (text) => {
            const input = document.createElement("input");
            input.value = text;
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
            Toast('success', '复制成功', 2);
        }

        const handleMenuClick = (e, record) => {
            const { key } = e;
            switch (key) {
                case 'update':
                    handleUpdateLiterature('update', record);
                    break;
                case 'delete':
                    handleDeleteLiterature(record);
                    break;
                case 'copy':
                    copyText(getCopyLink(record));
                    break;
                default:
                    break;
            }
        };

        const handleUpdateDeativeate = (status, record) => {
            record.isDeactivate = !status;
            saveProductInfo({
                id: record.id,
                isDeactivate: status,
            }).then((res) => {
                const type = res.code === 200 ? 'success' : 'warning';
                Toast(type, res.message, 3);
                if (res.code === 200 && res.message === '成功') record.isDeactivate = status;
            });
        };


        const previewRecord = (record) => {
            if (!record.content) return Toast('warning', '请添加内容', 3);

            reviewModalRef.value.showModal(record.content);
        };

        const handleSyncPV = debounce(() => {
            syncProductInfoPV().then((res) => {
                const { code, message } = res;
                const type = code == 200 ? 'success' : 'warning';
                Toast(type, message, 3);
                getData();
            }).catch((err) => {

            });
        })

        getData();

        return {
            getData,
            handleSyncPV,
            table,
            columns,
            optionsByProduct,
            options,
            catalogOptions,
            allCatalogOptions,
            literatureFormRef,
            requestPayload,
            allProductOptions,
            reviewModalRef,
            previewRecord,
            handleUpdateDeativeate,
            handleMenuClick,
            handleUpdateLiterature,
            handleDeleteLiterature,
            handleSelectProduct,
        };
    },
});
</script>

<style scoped lang="less">
.literature-page {
    width: 100%;
    height: calc(100vh - 120px);
    border-radius: 10px;
    box-shadow: 0 0 10px 0 #ccc;
    background: #fff;
    padding: 20px;

    .space {
        margin-top: 20px;
    }
}
</style>
